import axios from "axios";
import { BASE_URL } from "../config";

export function login(id) {
  return axios.post(`${BASE_URL}/api/login`, {
    username: id.username,
    password: id.password,
  });
}
